import React from 'react';

import { FormContainer } from '@eika-kortbetjening/form-container';
import { Button } from '@eika/button';
import { ErrorCard, SuccessCard } from '@eika/card';
import { Loader } from '@eika/loader';

import { useNavigate } from '@domain/app';
import useText from '@hooks/use-text';
import { goToRoot } from '@utils/url-utils';

interface SummaryModalContentProps {
    error: null | Error;
    isPending: boolean;
}

const SummaryModalContent = ({
    error: closingAccountError,
    isPending: isClosingCreditAccount,
}: SummaryModalContentProps) => {
    const {
        summaryModalContentSuccess1,
        summaryModalContentSuccess2,
        summaryModalSuccessCardTitle,
        summaryModalErrorMessage,
        summaryGoBackToCard,
    } = useText();
    const navigate = useNavigate();

    return (
        <FormContainer>
            <FormContainer.Content>
                {isClosingCreditAccount && <Loader />}
                {!closingAccountError ? (
                    <SuccessCard title={summaryModalSuccessCardTitle} centeredWithMargin>
                        <p>{summaryModalContentSuccess1}</p>
                        <p>{summaryModalContentSuccess2}</p>
                    </SuccessCard>
                ) : (
                    <ErrorCard title={closingAccountError?.message ?? summaryModalErrorMessage} />
                )}
            </FormContainer.Content>
            <FormContainer.Footer>
                <Button onClick={() => goToRoot(navigate)}>{summaryGoBackToCard}</Button>
            </FormContainer.Footer>
        </FormContainer>
    );
};

export default SummaryModalContent;
